import { api } from 'config'

export const BONUS_URL = {
   getBonuses: `${api.public}v1/customerGroup`,
   save: `${api.public}v1/customerGroup`,
   change: `${api.public}v1/customerGroup`,
   delete: `${api.public}v1/customerGroup`
}
